import { useEffect, useState } from "react";
import axios from "axios";
import { Lock, RefreshCw, Phone, MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [token, setToken] = useState(localStorage.getItem("ova_admin_token") || "");
  const [draftToken, setDraftToken] = useState("");
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async (tok) => {
    setLoading(true); setError("");
    try {
      const url = `${API}/leads${tok ? `?token=${encodeURIComponent(tok)}` : ""}`;
      const { data } = await axios.get(url);
      setLeads(data);
    } catch (e) {
      if (e?.response?.status === 401) setError("Token invalide.");
      else setError("Erreur de chargement.");
      setLeads([]);
    } finally { setLoading(false); }
  };

  useEffect(() => { if (token) load(token); else load(""); }, [token]);

  const onLogin = (e) => {
    e.preventDefault();
    localStorage.setItem("ova_admin_token", draftToken);
    setToken(draftToken);
  };

  return (
    <main data-testid="admin-page" className="min-h-screen bg-[var(--ova-paper)]">
      <header className="bg-white border-b hairline">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 h-[64px] flex items-center justify-between">
          <a href="/" className="font-display text-[22px]">Ova<span className="text-[var(--ova-orange)]">.</span> <span className="text-[11px] uppercase tracking-[0.25em] text-[var(--ova-mute)] ml-2">Admin</span></a>
          <button data-testid="admin-refresh" onClick={()=>load(token)} className="btn-outline-dark text-[12px] uppercase tracking-[0.18em] px-4 py-2 inline-flex items-center gap-2"><RefreshCw size={14}/> Actualiser</button>
        </div>
      </header>

      <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-12">
        {error === "Token invalide." && (
          <form onSubmit={onLogin} data-testid="admin-login" className="mb-10 card-soft bg-white p-8 border hairline max-w-md">
            <div className="flex items-center gap-2 mb-4 text-[12px] uppercase tracking-[0.22em] text-[var(--ova-mute)]"><Lock size={14}/> Token administrateur</div>
            <input data-testid="admin-token-input" type="password" value={draftToken} onChange={(e)=>setDraftToken(e.target.value)} placeholder="Saisissez votre token" className="field w-full px-4 py-3.5 mb-4" />
            <button data-testid="admin-login-btn" type="submit" className="btn-dark w-full py-3.5 text-[12px] uppercase tracking-[0.2em]">Accéder</button>
          </form>
        )}

        <div className="flex items-baseline justify-between mb-8">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--ova-mute)]">Tableau de bord</div>
            <h1 className="font-display text-[40px] mt-2 leading-none">Demandes reçues<span className="text-[var(--ova-orange)]">.</span></h1>
          </div>
          <div className="text-[12px] text-[var(--ova-mute)]">{leads.length} demande{leads.length>1?"s":""}</div>
        </div>

        <div className="bg-white border hairline card-soft overflow-hidden">
          <table className="w-full text-[13px]" data-testid="leads-table">
            <thead className="bg-[var(--ova-paper)] text-[10px] uppercase tracking-[0.22em] text-[var(--ova-mute)]">
              <tr>
                <th className="text-left p-4">Date</th>
                <th className="text-left p-4">Nom</th>
                <th className="text-left p-4">Plaque</th>
                <th className="text-left p-4">Pièce</th>
                <th className="text-left p-4">Téléphone</th>
                <th className="text-left p-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="p-8 text-center text-[var(--ova-mute)]">Chargement…</td></tr>}
              {!loading && leads.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-[var(--ova-mute)]">Aucune demande.</td></tr>}
              {leads.map((l) => (
                <tr key={l.id} data-testid={`lead-row-${l.id}`} className="border-t hairline align-top">
                  <td className="p-4 whitespace-nowrap text-[var(--ova-mute)]">{new Date(l.created_at).toLocaleString('fr-FR')}</td>
                  <td className="p-4">{l.name || "—"}</td>
                  <td className="p-4 font-mono text-[12px]">{l.plate || "—"}</td>
                  <td className="p-4 max-w-md">{l.part}</td>
                  <td className="p-4 whitespace-nowrap">{l.phone}</td>
                  <td className="p-4 whitespace-nowrap">
                    <a href={`tel:${l.phone}`} className="inline-flex items-center gap-1 mr-3 text-[var(--ova-ink)] hover:text-[var(--ova-orange)]"><Phone size={13}/> Appel</a>
                    <a href={`https://wa.me/${l.phone.replace(/^\+/,'').replace(/\D/g,'')}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[var(--ova-ink)] hover:text-[var(--ova-orange)]"><MessageCircle size={13}/> WhatsApp</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
}
